import { Button, Modal } from 'antd-mobile'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface DialogErrorProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const DialogError: React.FC<DialogErrorProps> = ({ open, onOpenChange }) => {
  const { t } = useTranslation()
  return (
    <Modal
      visible={open}
      closeOnMaskClick={true}
      onClose={() => {
        onOpenChange(false)
      }}
      maskClassName="__CustomMask__bg"
      content={
        <div>
          <div className="text-center text-xl font-bold mt-1">{t('common.error')}</div>
          <div className="text-center text-base font-medium mt-2">{t('common.payError')}</div>
          <Button
            onClick={() => {
              onOpenChange(false)
            }}
            type="button"
            className="w-full mt-5 h-12 rounded-full bg-gradient-to-r from-[rgba(254,153,33,1)] to-[rgba(255,66,59,1)] text-white font-medium text-base border-0">
            {t('common.close')}
          </Button>
        </div>
      }></Modal>
  )
}

export default DialogError
